'use strict';

var _ = require('lodash');
var MarketGridsController = function MarketGridsController($scope, $rootScope, $timeout, transitionDataService, marketGridsData, marketGridsUtils, applicableSeasonsLoadingService, dataRetrieverConstantsService, gridRecordsNavigationService, toolbarNextPreviousButtonService, marketAnalysisPanelService) {
  $scope.getMarketGridsParams = function () {
    return {
      selected: $scope.selected,
      flowMarkets: $scope.flowMarkets,
      demandManagementData: $scope.demandManagementData,
      filterCache: $scope.filterCache,
      previewCache: $scope.reoptPreviewData.previewCache
    };
  };
  $scope.viewInitialized = false;
  $scope.VIEW = {
    MARKET: 'market-demand-analysis',
    MARKET_PRODUCT: 'market-product-group-analysis',
    SERVICE: 'service-demand-analysis'
  };
  $scope.views = [{
    label: 'Market',
    value: $scope.VIEW.MARKET,
    disabled: false
  }, {
    label: 'Market Product',
    value: $scope.VIEW.MARKET_PRODUCT,
    disabled: false
  }, {
    label: 'Service',
    value: $scope.VIEW.SERVICE,
    disabled: false
  }];
  function adjustTabButtonsAvailability(enabled) {
    $scope.views[1].disabled = !enabled;
    $scope.views[2].disabled = !enabled;
  }
  $scope.goToTab = function (tab) {
    $scope.selected.tab = tab;
  };
  $scope.goToServiceTab = function () {
    $scope.goToTab($scope.VIEW.SERVICE);
  };
  function resetMarketProductSelectionIds() {
    $scope.selected.ids = [];
    $scope.marketProductIdsModified = false;
  }
  function resetMarketSelection() {
    $scope.marketPosesModified = false;
    $scope.selected.market = undefined;
    $scope.selected.poses = [];
  }
  function resetSelectedTab() {
    $scope.selected = {};
    $scope.filterCache = {};
    $scope.reoptPreviewData.previewCache = {};
    resetMarketSelection();
    $scope.selected.classGroups = [];
    $scope.flowMarkets = [];
    $scope.goToTab($scope.VIEW.MARKET_PRODUCT);
    adjustTabButtonsAvailability(true);
    resetMarketProductSelectionIds();
  }
  resetSelectedTab();
  $scope.isSet = function (tabName) {
    return $scope.selected.tab === tabName;
  };
  $scope.demandManagementDataSet = function () {
    return $scope.demandManagementData !== undefined;
  };
  $scope.isGridVisible = function (tabName) {
    return $scope.demandManagementDataSet() && $scope.isSet(tabName);
  };
  function getInitialMarket() {
    var main = $scope.demandManagementData.main;
    return main.origin + '-' + main.destination;
  }
  $scope.sendGridEvents = function (selectionFilters, filterChanged) {
    if ($scope.isSet($scope.VIEW.SERVICE)) {
      $scope.$broadcast('service-analysis:oneDaySelected', true);
      $scope.$broadcast('search-criteria:searchChangeEvent');
    } else {
      //we want to reload the grid only if the filter changes
      if (filterChanged) {
        $timeout(function () {
          $scope.$broadcast('grid:loadData:' + $scope.selected.tab, selectionFilters);
        }, 0);
      } else {
        $scope.$broadcast('grid:clearAndSelect:' + $scope.selected.tab, selectionFilters);
      }
    }
  };
  $scope.reloadGrid = function () {
    if ($scope.demandManagementDataSet()) {
      var filterChanged = marketGridsData.prepareDataRetrievers($scope.getMarketGridsParams());
      $scope.sendGridEvents($scope.getSelectionFilters(), filterChanged);
    }
  };
  $scope.$watch('reoptPreviewData.mdReopt.read', function (newValue, oldValue) {
    if (newValue || oldValue) {
      $scope.reoptPreviewData.previewCache = {};
      if (_.has($scope.getMarketGridsParams(), 'selected.tab')) {
        $scope.reoptPreviewData.previewCache[$scope.getMarketGridsParams().selected.tab] = true;
      }
    }
  });
  $scope.resetMarketDataRetrievers = function () {
    marketGridsData.resetDataRetrievers();
  };
  function getUniqServiceMarkets() {
    return mapUniq($scope.demandManagementData.serviceClasses, 'market');
  }
  function getMarketSelectionFilters() {
    var filters = _.map(getUniqServiceMarkets(), function (market) {
      return {
        market: market
      };
    });
    if (_.isEmpty(filters)) {
      // the initial selection of all POSes of the selected market
      if (_.isEmpty($scope.selected.poses)) {
        filters.push({
          market: $scope.selected.market
        });
      } else {
        _.forEach($scope.selected.poses, function (pos) {
          filters.push({
            market: $scope.selected.market,
            posName: pos
          });
        });
      }
    }
    return filters;
  }
  function getMarketProductSelectionFilters() {
    var filters = [];
    _.forEach($scope.selected.ids, function (entryKey) {
      filters.push({
        entryKey: entryKey
      });
    });

    // the initial selection of all class groups of the selected cabin(s)
    if (_.isEmpty($scope.selected.ids)) {
      _.forEach($scope.selected.classGroups, function (classGroup) {
        filters.push({
          classGroup: classGroup
        });
      });
    }
    return filters;
  }
  function loadSeasonsForGridDropdowns(flowMarkets) {
    applicableSeasonsLoadingService.loadApplicableSeasons(flowMarkets, dataRetrieverConstantsService.MARKET_SCREEN);
  }
  $scope.getSelectionFilters = function () {
    if ($scope.isSet($scope.VIEW.MARKET)) {
      return getMarketSelectionFilters();
    } else if ($scope.isSet($scope.VIEW.MARKET_PRODUCT)) {
      return getMarketProductSelectionFilters();
    }
    return [];
  };
  function adjustSelectedClassGroups(forceNewSelection) {
    var data = $scope.demandManagementData;
    if (forceNewSelection) {
      resetMarketProductSelectionIds();
    }
    if (forceNewSelection || _.isEmpty($scope.selected.ids) && !$scope.marketProductIdsModified) {
      $scope.selected.classGroups = marketGridsUtils.cabinsClassesToProductGroups({
        cabins: data.cabins,
        classes: _.concat(data.classes, data.segmentClasses, mapUniq(data.serviceClasses, 'className')),
        market: $scope.selected.market
      });
    }
  }
  function resetOldDataToApplyCcmChangesAtService() {
    if (transitionDataService.has($scope.VIEW.SERVICE)) {
      $scope.$broadcast('grid:undo', $scope.VIEW.SERVICE);
    }
  }
  $scope.selectedTabChanged = function () {
    if ($scope.demandManagementDataSet() && $scope.viewInitialized) {
      adjustSelectedClassGroups(false);
      $scope.reloadGrid();
      resetOldDataToApplyCcmChangesAtService();
    }
  };
  $scope.demandManagementDataChanged = function (newValue, oldValue) {
    gridRecordsNavigationService.setDemandManagementGridDisplayed($scope.demandManagementDataSet());
    if ($scope.demandManagementDataSet()) {
      if (!_.isEqual(newValue, oldValue) || !$scope.viewInitialized) {
        $scope.viewInitialized = true;
        marketGridsData.getFlowMarkets($scope.demandManagementData).then(function (flowMarkets) {
          loadSeasonsForGridDropdowns(flowMarkets);
          var initialMarket = getInitialMarket();
          $scope.flowMarkets = flowMarkets;
          if (!_.includes(flowMarkets, initialMarket)) {
            flowMarkets.push(initialMarket);
          }
          $scope.selected.market = initialMarket;
          $scope.goToTab($scope.VIEW.MARKET_PRODUCT);
          adjustTabButtonsAvailability(true);
          adjustSelectedClassGroups(true);
          adjustSelectedTab();

          //loading Market grid data in background to have a collection of market-date keys
          //to use for Next/Prev Key navigation in Market Product grid
          $scope.marketRows = undefined;
          $scope.marketSelectedRowIndexes = undefined;
          $scope.marketSelectedRowFilters = undefined;
          $scope.marketAllRowFilters = undefined;
          var marketSelectionFilters = getMarketSelectionFilters();
          $timeout(function () {
            $scope.$broadcast('grid:loadData:' + $scope.VIEW.MARKET, marketSelectionFilters);
            $scope.reloadGrid();
          }, 0);
        });
      }
    } else {
      $scope.$broadcast('service-analysis:switch-view:' + $scope.VIEW.SERVICE, 'default-view');
      resetSelectedTab();
    }
  };
  function moreThanOneMarketSelectedInServices() {
    return _.size(getUniqServiceMarkets()) > 1;
  }
  function classGroupsMatchSelectedCabins() {
    var originalClassGroups = marketGridsUtils.cabinsClassesToProductGroups({
      cabins: $scope.demandManagementData.cabins,
      market: $scope.selected.market
    });
    return _.every($scope.selected.classGroups, function (c) {
      return _.includes(originalClassGroups, c);
    });
  }

  // if more than on market is selected go directly to Market tab and disable MP and Service
  function adjustSelectedTab() {
    if (moreThanOneMarketSelectedInServices()) {
      $scope.goToTab($scope.VIEW.MARKET);
      adjustTabButtonsAvailability(false);
    }
  }
  $scope.upperGridsSelectedClassesChanged = function (newValue, oldValue) {
    if ($scope.demandManagementDataSet() && !_.isEqual(newValue, oldValue)) {
      // if there was a change in selected services reset market selection
      if (!_.isEqual(newValue[3], oldValue[3])) {
        resetMarketSelection();
        $scope.selected.market = getInitialMarket();
      }

      // any modification in upper grids removes the custom selections
      adjustTabButtonsAvailability(true);
      adjustSelectedClassGroups(true);
      adjustSelectedTab();

      // if service is visible reload the data, otherwise just adjust row selection (the proper data is already loaded)
      if ($scope.isSet($scope.VIEW.SERVICE)) {
        if (classGroupsMatchSelectedCabins()) {
          $scope.reloadGrid();
        } else {
          $scope.goToTab($scope.VIEW.MARKET_PRODUCT);
        }
      } else {
        $scope.$broadcast('grid:clearAndSelect:' + $scope.selected.tab, $scope.getSelectionFilters());
      }
    }
  };
  function mapUniq(array, property) {
    return _.chain(array).map(property).uniq().value();
  }
  function getSelectedPos(selectedRows, allRows) {
    var availablePoses = mapUniq(allRows, 'posName');
    var selectedPoses = mapUniq(selectedRows, 'posName');
    return !_.isEqual(availablePoses, selectedPoses) ? selectedPoses : [];
  }
  function setMarketGridInformationAndTitle(selectedRows) {
    var selectedRowIndexes = [];
    if (selectedRows && selectedRows.length > 0) {
      _.forEach(selectedRows, function (selectedRow) {
        selectedRowIndexes.push($scope.marketRows.indexOf(selectedRow));
      });
    } else {
      _.forEach($scope.marketRows, function (row) {
        if (row.market === $scope.selected.market) {
          selectedRowIndexes.push($scope.marketRows.indexOf(row));
          selectedRows.push(row);
        }
      });
    }
    var selectedFilters = [];
    _.forEach(selectedRowIndexes, function (index) {
      selectedFilters.push($scope.marketAllRowFilters[index]);
    });
    var marketGridKey = toolbarNextPreviousButtonService.getRowKeyId('market-demand-analysis');
    gridRecordsNavigationService.setDMParentGridInformation($scope.marketRows, selectedRowIndexes, marketGridKey, selectedFilters, $scope.marketAllRowFilters);
    gridRecordsNavigationService.setDMParentTabTitle(toolbarNextPreviousButtonService.getGridTitle('market-demand-analysis', selectedRows, selectedFilters));
    $scope.$broadcast('grid:gridTitleUpdate');
  }
  $scope.marketRowSelectionHandler = function (selectedRows) {
    $scope.marketPosesModified = true;
    $scope.selected.poses = getSelectedPos(selectedRows, $scope.marketRows);
    var selectedMarkets = mapUniq(selectedRows, 'market');
    var oneMarketSelected = _.size(selectedMarkets) === 1;
    $scope.selected.market = oneMarketSelected ? selectedMarkets[0] : undefined;
    if ($scope.demandManagementData && $scope.demandManagementData.serviceClasses) {
      var serviceMarkets = getUniqServiceMarkets();
      var serviceMarketMatchSelectedMarket = _.isEmpty(serviceMarkets) || _.size(serviceMarkets) === 1 && serviceMarkets[0] === $scope.selected.market;
      adjustTabButtonsAvailability(oneMarketSelected && serviceMarketMatchSelectedMarket);
      adjustSelectedClassGroups(true);
      if ($scope.marketAllRowFilters && $scope.marketAllRowFilters.length > 0) {
        setMarketGridInformationAndTitle(selectedRows);
      }
    }
  };
  $scope.rowSelectionHandler = function (event, selectedRows, gridId, allRows, selectedRowIndexes, selectionFilters, visibleRowProperties) {
    // for service share drawer
    $scope.serviceFilterData = {};
    $scope.serviceFilterData.poses = marketAnalysisPanelService.getPoses(undefined, selectedRows);
    $scope.serviceFilterData.markets = marketAnalysisPanelService.getMarket(undefined, selectedRows);
    $scope.serviceFilterData.daysOfWeek = marketAnalysisPanelService.getDaysOfWeek(undefined, selectedRows);
    $scope.serviceFilterData.dateRanges = marketAnalysisPanelService.getDateRangesForService(undefined, selectedRows);
    $scope.serviceFilterData.serviceClasses = marketAnalysisPanelService.getServiceClasses(undefined, selectedRows);
    $scope.serviceFilterData.gridSelectionKeysMap = marketAnalysisPanelService.buildServiceShareSelectionKeysMap(selectedRows);

    // for inter-grid interactions
    if (gridId === $scope.VIEW.MARKET) {
      $scope.marketRows = visibleRowProperties && visibleRowProperties.displayRows;
      $scope.marketSelectedRowIndexes = visibleRowProperties && visibleRowProperties.displayRowIndexes;
      $scope.marketSelectedRowFilters = visibleRowProperties && visibleRowProperties.displayRowFilters;
      $scope.marketAllRowFilters = visibleRowProperties && visibleRowProperties.allRowFilters;
    }
    if (gridId === $scope.VIEW.MARKET && $scope.isSet($scope.VIEW.MARKET)) {
      var displaySelectedRows = [];
      if (visibleRowProperties) {
        _.forEach(visibleRowProperties.displayRowIndexes, function (index) {
          displaySelectedRows.push(visibleRowProperties.displayRows[index]);
        });
      }
      $scope.marketRowSelectionHandler(displaySelectedRows);
    }
    if (gridId === $scope.VIEW.MARKET_PRODUCT && $scope.isSet($scope.VIEW.MARKET_PRODUCT)) {
      $scope.marketProductIdsModified = true;
      $scope.selected.ids = _.map(selectedRows, 'entryKey');
      $scope.selected.classGroups = mapUniq(selectedRows, 'classGroup');
    }
    if (gridId === $scope.VIEW.MARKET && allRows && allRows.length > 0) {
      var marketSelectedRows = [];
      if (visibleRowProperties) {
        _.forEach(visibleRowProperties.displayRowIndexes, function (index) {
          marketSelectedRows.push(visibleRowProperties.displayRows[index]);
        });
      }
      setMarketGridInformationAndTitle(marketSelectedRows);
    }
  };
  $scope.applyCcmChangesToServiceGrid = function (event, gridData, gridId) {
    if (gridId === $scope.VIEW.SERVICE && transitionDataService.has($scope.VIEW.SERVICE)) {
      $scope.$broadcast('grid:fillBulkOverrides', $scope.VIEW.SERVICE, transitionDataService.pop($scope.VIEW.SERVICE));
    }
  };
  function switchToMarket(direction) {
    var marketRows = direction === 'Next' ? gridRecordsNavigationService.getDMParentNextKeyRows() : gridRecordsNavigationService.getDMParentPreviousKeyRows();
    if (marketRows) {
      $scope.marketRowSelectionHandler(marketRows);
      $scope.reloadGrid();
    }
  }
  $scope.$on('grid:selectNextKey', function () {
    switchToMarket('Next');
  });
  $scope.$on('grid:selectPreviousKey', function () {
    switchToMarket('Previous');
  });
  $scope.$watch('selected.tab', function (newValue) {
    $scope.reoptPreviewData.visibleMarketGrid = newValue;
  });
};
MarketGridsController.$inject = ['$scope', '$rootScope', '$timeout', 'TransitionDataService', 'MarketGridsDataService', 'MarketGridsUtilsService', 'ApplicableSeasonsLoadingService', 'DataRetrieverConstantsService', 'GridRecordsNavigationService', 'ToolbarNextPreviousButtonService', 'MarketAnalysisPanelService'];
module.exports = MarketGridsController;